import { fetchJson } from "@/utils/fetch";
import { JobType } from "@/app/career/view-jobs/[id]/type";
import { extractJobIdAsNumber } from "@/utils/urls";

export async function fetchJobTypeClient(
  jobId: string,
  job_url?: string
): Promise<JobType | undefined> {
  // Extract id from url example: senior-berater-leitender-berater-997729
  const IdAfterLastDash = extractJobIdAsNumber(jobId);

  const queryParams = job_url ? { job_url } : undefined;

  const response = await fetchJson<JobType>(
    `/career/positions/${IdAfterLastDash}`,
    {
      ...(queryParams && { queryParams }),
      silentSentry: [302, 404, 502],
    }
  );
  return response;
}

